import { render, staticRenderFns } from "./class-compare-report.vue?vue&type=template&id=640fba53&scoped=true"
import script from "./class-compare-report.vue?vue&type=script&lang=js"
export * from "./class-compare-report.vue?vue&type=script&lang=js"
import style0 from "./class-compare-report.vue?vue&type=style&index=0&id=640fba53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640fba53",
  null
  
)

export default component.exports